export const DATETIME_CATEGORY_LIST_ACTION = 'collect/DATETIME_CATEGORY_LIST_ACTION'
export const CONTENT_CATEGORY_LIST_ACTION = 'collect/CONTENT_CATEGORY_LIST_ACTION'
export const COLLECTION_CONVERSATION_LIST = 'collect/COLLECTION_CONVERSATION_LIST'
export const COLLECTION_MESSAGE_LIST = 'collect/COLLECTION_MESSAGE_LIST'
export const SET_MALL_COMPONENTS_LIST = 'collect/SET_MALL_COMPONENTS_LIST'
